import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/Index'
  },
    {
      path: '/Index',
      name: 'Index',
      component: () => import ("@/views/Index/Index.vue")
    },
    {
      path: '/Publication',
      name: 'Publication',
      component: () => import ("@/views/Publication/Publication.vue")
    },
    {
      path: '/pdf',
      name: 'pdf',
      component: () => import ("@/views/Publication/pdf.vue")
    },
    {
      path: '/JoinUs',
      name: 'JoinUs',
      component: () => import ("@/views/JoinUs/JoinUs.vue")
    },
    {
      path: '/ContactUS',
      name: 'ContactUS',
      component: () => import ("@/views/ContactUS/ContactUS.vue")
    },
    {
      path: '/News',
      name: 'News',
      component: () => import ("@/views/News/News.vue")
    },
    {
      path: '/Company',
      name: 'Company',
      component: () => import ("@/views/Company/Company.vue")
    },
    {
      path: '/Technological',
      name: 'Technological',
      component: () => import ("@/views/Technological/Technological.vue")
    },
    {
      path: '/Founder',
      name: 'Founder',
      component: () => import ("@/views/Founder/Founder.vue")
    },
    {
      path: '/FounderSong',
      name: 'FounderSong',
      component: () => import ("@/views/FounderSong/FounderSong.vue")
    },
    {
      path: '/FounderWei',
      name: 'FounderWei',
      component: () => import ("@/views/FounderWei/FounderWei.vue")
    },
    {
      path: '/Pipeline',
      name: 'Pipeline',
      component: () => import ("@/views/Pipeline/Pipeline.vue")
    },
    {
      path: '/JoinDetail',
      name: 'JoinDetail',
      component: () => import ("@/views/JoinDetail/JoinDetail.vue")
    },
    {
      path: '/NewsDetail',
      name: 'NewsDetail',
      component: () => import ("@/views/NewsDetail/NewsDetail.vue")
    },
    {
      path: '/Detail02',
      name: 'Detail02',
      component: () => import ("@/views/NewsDetail/Detail02.vue")
    },
    {
      path: '/Detail03',
      name: 'Detail03',
      component: () => import ("@/views/NewsDetail/Detail03.vue")
    },
    {
      path: '/Detail04',
      name: 'Detail04',
      component: () => import ("@/views/NewsDetail/Detail04.vue")
    },
    {
      path: '/Detail05',
      name: 'Detail05',
      component: () => import ("@/views/NewsDetail/Detail05.vue")
    },
    {
      path: '/Detail06',
      name: 'Detail06',
      component: () => import ("@/views/NewsDetail/Detail06.vue")
    },
    {
      path: '/Detail07',
      name: 'Detail07',
      component: () => import ("@/views/NewsDetail/Detail07.vue")
    },
    {
      path: '/Detail08',
      name: 'Detail08',
      component: () => import ("@/views/NewsDetail/Detail08.vue")
    },
    {
      path: '/Detail09',
      name: 'Detail09',
      component: () => import ("@/views/NewsDetail/Detail09.vue")
    },
    {
      path: '/Detail10',
      name: 'Detail10',
      component: () => import ("@/views/NewsDetail/Detail10.vue")
    },
    {
      path: '/Detail11',
      name: 'Detail11',
      component: () => import ("@/views/NewsDetail/Detail11.vue")
    },
    {
      path: '/Detail12',
      name: 'Detail12',
      component: () => import ("@/views/NewsDetail/Detail12.vue")
    },
    {
      path: '/Detail13',
      name: 'Detail13',
      component: () => import ("@/views/NewsDetail/Detail13.vue")
    },
    {
      path: '/Detail14',
      name: 'Detail14',
      component: () => import ("@/views/NewsDetail/Detail14.vue")
    },
    {
      path: '/Detail15',
      name: 'Detail15',
      component: () => import ("@/views/NewsDetail/Detail15.vue")
    },
    {
      path: '/Detail16',
      name: 'Detail16',
      component: () => import ("@/views/NewsDetail/Detail16.vue")
    },
    {
      path: '/Detail17',
      name: 'Detail17',
      component: () => import ("@/views/NewsDetail/Detail17.vue")
    },
    {
      path: '/Detail18',
      name: 'Detail18',
      component: () => import ("@/views/NewsDetail/Detail18.vue")
    },{
      path: '/Detail19',
      name: 'Detail19',
      component: () => import ("@/views/NewsDetail/Detail19.vue")
    },
    {
      path: '/Detail20',
      name: 'Detail20',
      component: () => import ("@/views/NewsDetail/Detail20.vue")
    },
    {
      path: '/Detail21',
      name: 'Detail21',
      component: () => import ("@/views/NewsDetail/Detail21.vue")
    },
    {
      path: '/Detail22',
      name: 'Detail22',
      component: () => import ("@/views/NewsDetail/Detail22.vue")
    },
    {
      path: '/Detail23',
      name: 'Detail23',
      component: () => import ("@/views/NewsDetail/Detail23.vue")
    },
    {
      path: '/Detail24',
      name: 'Detail24',
      component: () => import ("@/views/NewsDetail/Detail24.vue")
    },
    {
      path: '/Detail25',
      name: 'Detail25',
      component: () => import ("@/views/NewsDetail/Detail25.vue")
    },
    {
      path: '/Detail26',
      name: 'Detail26',
      component: () => import ("@/views/NewsDetail/Detail26.vue")
    },
    {
      path: '/Detail27',
      name: 'Detail27',
      component: () => import ("@/views/NewsDetail/Detail27.vue")
    },
    {
      path: '/Detail28',
      name: 'Detail28',
      component: () => import ("@/views/NewsDetail/Detail28.vue")
    },
    {
      path: '/Detail29',
      name: 'Detail29',
      component: () => import ("@/views/NewsDetail/Detail29.vue")
    },
    {
      path: '/Detail30',
      name: 'Detail30',
      component: () => import ("@/views/NewsDetail/Detail30.vue")
    },
    {
      path: '/Detail31',
      name: 'Detail31',
      component: () => import ("@/views/NewsDetail/Detail31.vue")
    },
    {
      path: '/Detail32',
      name: 'Detail32',
      component: () => import ("@/views/NewsDetail/Detail32.vue")
    },
    {
      path: '/Detail33',
      name: 'Detail33',
      component: () => import ("@/views/NewsDetail/Detail33.vue")
    },
    {
      path: '/Detail34',
      name: 'Detail34',
      component: () => import ("@/views/NewsDetail/Detail34.vue")
    },
    {
      path: '/Detail35',
      name: 'Detail35',
      component: () => import ("@/views/NewsDetail/Detail35.vue")
    },
    {
      path: '/Detail36',
      name: 'Detail36',
      component: () => import ("@/views/NewsDetail/Detail36.vue")
    },
    {
      path: '/Detail37',
      name: 'Detail37',
      component: () => import ("@/views/NewsDetail/Detail37.vue")
    },
    {
      path: '/Detail38',
      name: 'Detail38',
      component: () => import ("@/views/NewsDetail/Detail38.vue")
    },
    {
      path: '/Detail39',
      name: 'Detail39',
      component: () => import ("@/views/NewsDetail/Detail39.vue")
    },
    {
      path: '/Trade',
      name: 'Trade',
      component: () => import ("@/views/Trade/Trade.vue")
    },
    {
      path: '/Trade02',
      name: 'Trade02',
      component: () => import ("@/views/Trade/Trade02.vue")
    },
    {
      path: '/Trade03',
      name: 'Trade03',
      component: () => import ("@/views/Trade/Trade03.vue")
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js